import { vec4 } from 'gl-matrix'
import { SnapshotFrom } from 'xstate'

import { RunnerActor } from '@/state/RunnerStateMachine'
import { RenderContext } from '@/webgl/core/RenderContext'
import { IScene } from '@/webgl/engine/IScene'
import Renderer from '@/webgl/Renderer'
import ILoadable from '@/webgl/runner/interfaces/ILoadable'

export default class DummyScenario implements IScene {
  constructor(renderer: Renderer) {
    renderer.clearColor = vec4.fromValues(0.2, 0.5, 1.0, 1)
  }

  load(abort: AbortSignal): Promise<void> {
    throw new Error('Method not implemented.')
  }

  setActor(actor: SnapshotFrom<RunnerActor>): void {
    throw new Error('Method not implemented.')
  }

  getLoadables(): ILoadable[] {
    return []
  }

  start(): void {}

  preRender(): void {}

  rttPass(): void {}

  render(context: RenderContext): void {}

  dispose(): void {}
}
